/**
 * 销售业绩成本/毛利核算可见角色：超管、管理员、财务
 */
export function canViewSaleCostProfit(userRole) {
  return ['super_admin', 'admin', 'finance'].includes(userRole)
}

export function amountFloorDiff(amount, floorAmount) {
  return Number(amount || 0) - Number(floorAmount || 0)
}

export function packageFloorDiff(packageAmount, floorAmount, rebateFee) {
  return Number(packageAmount || 0) - Number(rebateFee || 0) - Number(floorAmount || 0)
}

export function cardFloorDiff(cardAmount, floorAmount) {
  return amountFloorDiff(cardAmount, floorAmount)
}

export const monthlyFloorPairs = [
  ['additional_card_amount', 'card_floor_amount'],
  ['additional_product_amount', 'floor_amount'],
  ['additional_esim_amount', 'esim_floor_amount'],
  ['additional_profile_amount', 'profile_floor_amount'],
  ['additional_module_amount', 'module_floor_amount'],
  ['additional_cpe_amount', 'cpe_floor_amount']
]

export const agentAdditionalFloorPairs = [
  ['card_amount', 'card_floor_amount'],
  ['product_amount', 'floor_amount'],
  ['esim_amount', 'esim_floor_amount'],
  ['profile_amount', 'profile_floor_amount'],
  ['module_amount', 'module_floor_amount'],
  ['cpe_amount', 'cpe_floor_amount']
]

export function hasNegativeFloorDiff(record, pairs) {
  return pairs.some(([amountField, floorField]) => amountFloorDiff(record[amountField], record[floorField]) < 0)
}

export function amountColumn(title, dataIndex, format, sort) {
  return {
    title,
    customRender: format,
    dataIndex,
    sorter: true,
    sortOrder: sort && sort.sort_field === dataIndex ? sort.sort_order : false
  }
}

export function floorStatColumns(format, sort, floorField, diffField, floorTitle, diffTitle, amountField) {
  const columns = [
    {
      title: floorTitle,
      customRender: format,
      dataIndex: floorField
    },
    {
      title: diffTitle,
      customRender: (text, record) => format(amountFloorDiff(record[amountField], record[floorField])),
      dataIndex: diffField
    }
  ]
  if (sort) {
    columns[0].sorter = true
    columns[0].sortOrder = sort.sort_field === floorField ? sort.sort_order : false
    columns[1].sorter = true
    columns[1].sortOrder = sort.sort_field === diffField ? sort.sort_order : false
  }
  return columns
}

export function salePerformanceRecalculateContent(options = {}) {
  const shared = '套餐底价按上架套餐同周期底价计算，卡板底价按上架卡板底价乘以数量单独计算。eSIM、Profile、模组、CPE 底价按上架底价乘以数量计算，与卡板同一口径。返佣费用是零售价减去客户价，渠道上下级价差不计入。套餐底价差等于套餐费用减去返佣费用再减去套餐底价。快递费是预制单寄付、已计入账单金额的部分，单独列出。单笔毛利为账单金额减去返佣费用、各项底价之和再减去快递费。销售毛利为新增毛利与存量毛利之和。'
  const ending = options.useLatestFloorPrice
    ? '本次按当前最新上架套餐、卡板及硬件底价重新计算，不沿用已有底价快照。计算在后台进行，完成后请刷新页面。'
    : '已有同周期底价快照会沿用。计算在后台进行，完成后请刷新页面。'
  return shared + ending
}
